// extracted by mini-css-extract-plugin
export default {"form":"Login_form__WTPNw","email":"Login_email__PwspU","password":"Login_password__9RwVl","login":"Login_login__WBynq","note":"Login_note__D7JT+","link":"Login_link__bImuD"};